export const REVIEW_ACTIONS = Object.freeze(['restore', 'delete', 'restore_deleted']);

export function normalizePagination(limit = 50, offset = 0) {
  const parsedLimit = Number(limit);
  const parsedOffset = Number(offset);

  return {
    limit: Number.isInteger(parsedLimit) ? Math.max(1, Math.min(100, parsedLimit)) : 50,
    offset: Number.isInteger(parsedOffset) ? Math.max(0, parsedOffset) : 0,
  };
}

export function normalizeReviewTasksResponse(response) {
  return response && Array.isArray(response.data) ? response.data : [];
}

export function buildReviewActionPayload(action, note = '') {
  if (!REVIEW_ACTIONS.includes(action)) {
    throw new Error('Invalid review action');
  }

  const normalizedNote = String(note || '').trim();

  return {
    action,
    note: normalizedNote || null,
  };
}

export async function fetchReviewTasks(app, pagination = {}) {
  const { limit, offset } = normalizePagination(pagination.limit, pagination.offset);
  const query = `page%5Blimit%5D=${limit}&page%5Boffset%5D=${offset}`;
  const response = await app.request({
    method: 'GET',
    url: `${app.forum.attribute('apiUrl')}/yingtao/review-tasks?${query}`,
  });

  return normalizeReviewTasksResponse(response);
}

export async function resolveReviewTask(app, taskId, action, note = '') {
  const response = await app.request({
    method: 'POST',
    url: `${app.forum.attribute('apiUrl')}/yingtao/review-tasks/${taskId}/resolve`,
    body: buildReviewActionPayload(action, note),
  });

  if (!response || !response.data || typeof response.data !== 'object') {
    throw new Error('Invalid review response');
  }

  return response.data;
}
